import React, { useState, useEffect } from 'react';
import { BellIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { notificationService } from '../services/notifications';

export const NotificationPermission: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if ('Notification' in window) {
      // Show banner if notifications are supported but not yet granted/denied
      if (Notification.permission === 'default') {
        // Check if user has dismissed the banner before
        const dismissed = localStorage.getItem('notification-banner-dismissed');
        if (!dismissed) {
          setShowBanner(true);
        }
      }
    }
  }, []);

  const handleEnableNotifications = async () => {
    const granted = await notificationService.requestPermission();
    setShowBanner(false);
    if (granted) {
      localStorage.setItem('notification-permission-requested', 'true');
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('notification-banner-dismissed', 'true');
  };

  if (!showBanner || !('Notification' in window)) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 max-w-md bg-widget-bg border border-primary rounded-lg shadow-lg p-4 z-50">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <BellIcon className="h-6 w-6 text-primary" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-heading">Enable Notifications</h3>
          <p className="mt-1 text-sm text-body-color">
            We notify you when a job finishes or needs attention.
          </p>
          <div className="mt-3 flex gap-2">
            <button
              onClick={handleEnableNotifications}
              className="btn-primary py-1 text-sm"
            >
              Enable
            </button>
            <button
              onClick={handleDismiss}
              className="btn-secondary py-1 text-sm"
            >
              Not now
            </button>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="ml-3 flex-shrink-0 text-secondary hover:text-body-color"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};